import { render } from "./ChooseClass.vue?vue&type=template&id=d3163e2a&scoped=true"
import script from "./ChooseClass.vue?vue&type=script&lang=js"
export * from "./ChooseClass.vue?vue&type=script&lang=js"

import "./ChooseClass.vue?vue&type=style&index=0&id=d3163e2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3163e2a"]])

export default __exports__